<template>
  <div class="p-message-search">
    <form action="/" method="get">
      <div class="p-message-search-keyword">
        <div class="c-input u-text-left display-condition">
          <button
            :class="{ 'is-active': isDisplayCondition }"
            class="c-btn c-btn--gray u-w120 u-h32 u-fs--s"
            type="button"
            name="open_condition_detail"
            value="open_condition_detail"
            @click="onClickDisplayCondition"
          >
            <p class="c-btn__text">表示項目</p>
          </button>
        </div>
        <div class="c-input u-w400">
          <input
            v-model="updatePushName"
            class="c-input__item c-input__item--overlay-ico"
            type="text"
            name="push_name"
            value=""
            placeholder="プッシュ名・タイトル・メッセージで検索"
          />
          <div class="c-input__icon c-input__icon--overlay" @click="onSearchClick($event)">
            <div class="c-icon c-icon--white u-wh30">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <use xlink:href="/assets/img/sprite.svg#search" />
              </svg>
            </div>
          </div>
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
        <button
          :class="{ 'is-active': isSearchCondition }"
          class="c-btn c-btn--gray u-w120 u-h32 u-fs--s"
          type="button"
          name="open_condition_detail"
          value="open_condition_detail"
          @click="onClickSearchCondition"
        >
          <p class="c-btn__text">詳細検索</p>
        </button>
      </div>

      <div
        class="p-message-search-condition bubble-left"
        :class="{ 'is-active': isDisplayCondition }"
      >

        <div class="c-title u-w1200 p-message-search-with-clear">
          <div class="c-title__text u-fs22">表示項目の変更</div>
        </div>

        <div class="p-message-search-condition__row">
          <div class="c-checkbox u-w800">
            <ul class="c-checkbox-list">
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="displayItems.messageId"
                    type="checkbox"
                    name="messageId"
                    :value="true"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">メッセージID</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="displayItems.messageName"
                    type="checkbox"
                    name="messageName"
                    :value="true"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">プッシュ名</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="displayItems.messageTitle"
                    type="checkbox"
                    name="messageTitle"
                    :value="true"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">タイトル・メッセージ</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="displayItems.deliverType"
                    type="checkbox"
                    name="deliverType"
                    :value="true"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">通知種別</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="displayItems.deliveryDateFrom"
                    type="checkbox"
                    name="deliveryDateFrom"
                    :value="true"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">配信予定</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="displayItems.deliveryDateTo"
                    type="checkbox"
                    name="deliveryDateTo"
                    :value="true"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">配信終了</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="displayItems.deliverStatus"
                    type="checkbox"
                    name="deliverStatus"
                    :value="true"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">配信状況</div>
                  </div>
                </label>
              </li>
            </ul>
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="p-message-search-condition"
        :class="{ 'is-active': isSearchCondition }"
      >
        <div class="c-title u-w1200 p-message-search-with-clear">
          <div class="c-title__text u-fs22">絞り込み条件の追加</div>
          <button
            type="button"
            name="search_exec"
            value="search_exec"
            class="c-btn c-btn--blue u-w200 u-h34 u-fs14"
            style="margin-left: auto; margin-right: 20px;"
            @click="onSearchClick($event)"
          >
            <p class="c-btn__text">検索実行</p>
          </button>
          <button
            type="button"
            name="clear"
            value="clear"
            class="c-btn c-btn--modal c-btn--gray u-w200 u-h34 u-fs14"
            @click="onClickClearButton"
          >
            <p class="c-btn__text">条件クリア</p>
          </button>
        </div>
        <div class="p-message-search-condition__row p-message-search-condition__row--dates" style="width: 600px;">
          <div class="c-input c-input--date-from">
            <div class="c-input__title">配信開始日</div>
            <div class="c-input-group">
              <datepicker
                ref="refDeliveryStartDateFrom"
                v-model="updateStartDateFrom"
                name="delivery_start_date_from"
                format="yyyy/MM/dd"
                placeholder="YYYY/MM/DD"
                input-class="c-input__item c-input__item--overlay-ico u-w190"
                calendar-class="datepicker_calendar"
                :language="ja"
              />
              <svg
                class="c-input--date-clear"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                @click="clearDate($event, 'updateStartDateFrom')"
              >
                <use xlink:href="/assets/img/sprite.svg#close" />
              </svg>
              <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_start_date_from')">
                <div class="c-icon c-icon--white u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#calendar" />
                  </svg>
                </div>
              </div>
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
          <div class="c-input">
            <datepicker
              ref="refDeliveryStartDateTo"
              v-model="updateStartDateTo"
              name="delivery_start_date_to"
              format="yyyy/MM/dd"
              placeholder="YYYY/MM/DD"
              input-class="c-input__item c-input__item--overlay-ico u-w190"
              calendar-class="datepicker_calendar"
              :language="ja"
            />
            <svg
              class="c-input--date-clear"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              @click="clearDate($event, 'updateStartDateTo')"
            >
              <use xlink:href="/assets/img/sprite.svg#close" />
            </svg>
            <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_start_date_to')">
              <div class="c-icon c-icon--white u-wh22">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use xlink:href="/assets/img/sprite.svg#calendar" />
                </svg>
              </div>
            </div>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
          <div class="c-input c-input--date-from">
            <div class="c-input__title">配信終了日</div>
            <div class="c-input-group">
              <datepicker
                ref="refDeliveryEndDateFrom"
                v-model="updateEndDateFrom"
                name="delivery_end_date_from"
                format="yyyy/MM/dd"
                placeholder="YYYY/MM/DD"
                input-class="c-input__item c-input__item--overlay-ico u-w190"
                calendar-class="datepicker_calendar"
                :language="ja"
              />
              <svg
                class="c-input--date-clear"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                @click="clearDate($event, 'updateEndDateFrom')"
              >
                <use xlink:href="/assets/img/sprite.svg#close" />
              </svg>
              <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_end_date_from')">
                <div class="c-icon c-icon--white u-wh22">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#calendar" />
                  </svg>
                </div>
              </div>
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
          <div class="c-input">
            <datepicker
              ref="refDeliveryEndDateTo"
              v-model="updateEndDateTo"
              name="delivery_end_date_to"
              format="yyyy/MM/dd"
              placeholder="YYYY/MM/DD"
              input-class="c-input__item c-input__item--overlay-ico u-w190"
              calendar-class="datepicker_calendar"
              :language="ja"
            />
            <svg
              class="c-input--date-clear"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              @click="clearDate($event, 'updateEndDateTo')"
            >
              <use xlink:href="/assets/img/sprite.svg#close" />
            </svg>
            <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_end_date_to')">
              <div class="c-icon c-icon--white u-wh22">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use xlink:href="/assets/img/sprite.svg#calendar" />
                </svg>
              </div>
            </div>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-search-condition__row">
          <div class="c-checkbox u-w364">
            <div class="c-checkbox__title">通知種別</div>
            <ul class="c-checkbox-list">
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverTypes"
                    type="checkbox"
                    name="push_timing"
                    :value="messageInfo.deliverTypeValues['Immediate']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">即時</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverTypes"
                    type="checkbox"
                    name="push_timing"
                    :value="messageInfo.deliverTypeValues['Reserve']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">予約</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverTypes"
                    type="checkbox"
                    name="push_timing"
                    :value="messageInfo.deliverTypeValues['Period']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">期間</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverTypes"
                    type="checkbox"
                    name="push_timing"
                    :value="messageInfo.deliverTypeValues['Regular']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">定期</div>
                  </div>
                </label>
              </li>
            </ul>
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
          <div class="c-checkbox u-w510">
            <div class="c-checkbox__title">配信状況</div>
            <ul class="c-checkbox-list">
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverStatuses"
                    type="checkbox"
                    name="delivery_status"
                    :value="messageInfo.deliverStatusValues['Save']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">保存</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverStatuses"
                    type="checkbox"
                    name="delivery_status"
                    :value="messageInfo.deliverStatusValues['Wait']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">配信待ち</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverStatuses"
                    type="checkbox"
                    name="delivery_status"
                    :value="messageInfo.deliverStatusValues['Active']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">配信中</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverStatuses"
                    type="checkbox"
                    name="delivery_status"
                    :value="messageInfo.deliverStatusValues['Complete']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">配信済</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedDeliverStatuses"
                    type="checkbox"
                    name="delivery_status"
                    :value="messageInfo.deliverStatusValues['Stop']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">配信停止</div>
                  </div>
                </label>
              </li>
            </ul>
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-search-condition__row">
          <div class="c-checkbox u-w364">
            <div class="c-checkbox__title">配信種別</div>
            <ul class="c-checkbox-list">
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedMessageTypes"
                    type="checkbox"
                    name="media_type"
                    :value="messageInfo.messageTypeValues['Image']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">画像/テキスト</div>
                  </div>
                </label>
              </li>
            </ul>
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
          <div class="c-checkbox u-w510">
            <div class="c-checkbox__title">プッシュ対象</div>
            <ul class="c-checkbox-list">
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedServiceTypes"
                    type="checkbox"
                    name="push_type"
                    :value="messageInfo.serviceTypeValues['Browser']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">ブラウザ</div>
                  </div>
                </label>
              </li>
              <li class="c-checkbox-list__item">
                <label class="c-checkbox__label">
                  <input
                    v-model="selectedServiceTypes"
                    type="checkbox"
                    name="push_type"
                    :value="messageInfo.serviceTypeValues['Cart']"
                  />
                  <div class="c-checkbox__item">
                    <div class="c-checkbox__box"></div>
                    <div class="c-checkbox__box-label">カート</div>
                  </div>
                </label>
              </li>
            </ul>
            <div class="c-error">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-search-condition__row">
          <div class="c-checkbox u-w510">
            <div class="c-checkbox__title">広告配信</div>
            <div class="c-radio u-w100p">
              <ul class="c-checkbox-list">
                <li class="c-checkbox-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="selectedIsContainsAd"
                      type="radio"
                      name="is_contains_ad"
                      :value="1"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">全て</div>
                    </div>
                  </label>
                </li>
                <li class="c-checkbox-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="selectedIsContainsAd"
                      type="radio"
                      name="is_contains_ad"
                      :value="2"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">広告配信を除外</div>
                    </div>
                  </label>
                </li>
                <li class="c-checkbox-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="selectedIsContainsAd"
                      type="radio"
                      name="is_contains_ad"
                      :value="3"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">広告配信のみ</div>
                    </div>
                  </label>
                </li>
              </ul>
              <div class="c-error">
                <div class="c-error">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Datepicker from '../molecules/Datepicker.vue';
const ja = 'ja';
import moment from 'moment';

export default {
  components: {
    Datepicker,
  },
  props: {
    csrfToken: String,
    messageInfo: Object,
    loadData: { type: Function, required: true },
    pageCountReset: { type: Function, required: true },

    deliverTypes: {
      type: Array,
      required: true
    },
    deliverStatuses: {
      type: Array,
      required: true
    },
    messageTypes: {
      type: Array,
      required: true
    },
    serviceTypes: {
      type: Array,
      required: true
    },
    isContainsAd: {
      type: Number,
      required: true
    },
    pushName: {
      type: String,
      required: false,
      default: null
    },
    startDateFrom: {
      type: Date,
      required: false,
      default: null
    },
    startDateTo: {
      type: Date,
      required: false,
      default: null
    },
    endDateFrom: {
      type: Date,
      required: false,
      default: null
    },
    endDateTo: {
      type: Date,
      required: false,
      default: null
    },
    initialDisplayItems: {
      type: Object,
      required: true
    },
  },
  emits: ["update-push-name","update-start-date-from","update-start-date-to","update-end-date-from","update-end-date-to","update-is-contains-ad","update-deliver-types","update-deliver-statuses","update-message-types","update-service-types","update-display-items"],
  data () {
    return {
      ja:ja,
      isSearchCondition: false,
      isDisplayCondition: false,
      selectedDeliverTypes: [],
      selectedDeliverStatuses: [],
      selectedMessageTypes: [],
      selectedServiceTypes: [],
      displayItems: {},
    }
  },
  computed: {
    updatePushName: {
      get() {
        return this.pushName || null;
      },
      set(value) {
        this.$emit('update-push-name', value);
      }
    },
    updateStartDateFrom: {
      get() {
        return this.startDateFrom || null;
      },
      set(value) {
        this.$emit('update-start-date-from', value);
      }
    },
    updateStartDateTo: {
      get() {
        return this.startDateTo || null;
      },
      set(value) {
        this.$emit('update-start-date-to', value);
      }
    },
    updateEndDateFrom: {
      get() {
        return this.endDateFrom || null;
      },
      set(value) {
        this.$emit('update-end-date-from', value);
      }
    },
    updateEndDateTo: {
      get() {
        return this.endDateTo || null;
      },
      set(value) {
        this.$emit('update-end-date-to', value);
      }
    },
    selectedIsContainsAd: {
      get() {
        return this.isContainsAd || 1;
      },
      set(value) {
        this.$emit('update-is-contains-ad', value);
      }
    },
  },
  watch: {
    selectedDeliverTypes: {
      handler(newSelectedDeliverTypes) {
        this.$emit('update-deliver-types', newSelectedDeliverTypes);
      },
      deep: true,
    },
    selectedDeliverStatuses: {
      handler(newSelectedDeliverStatuses) {
        this.$emit('update-deliver-statuses', newSelectedDeliverStatuses);
      },
      deep: true,
    },
    selectedMessageTypes: {
      handler(newSelectedMessageTypes) {
        this.$emit('update-message-types', newSelectedMessageTypes);
      },
      deep: true,
    },
    selectedServiceTypes: {
      handler(newSelectedServiceTypes) {
        this.$emit('update-service-types', newSelectedServiceTypes);
      },
      deep: true,
    },
    selectedIsContainsAd(newSelectedIsContainsAd) {
      this.$emit('update-is-contains-ad', newSelectedIsContainsAd);
    },
    displayItems: {
      handler: function (newDisplayItems) {
        this.$emit('update-display-items', newDisplayItems);
      },
      deep: true
    },
  },
  mounted() {
    this.retrieveFromSessionStorage();
    this.displayItems = this.initialDisplayItems;
  },

  methods: {
    // クリック: 詳細検索ボタン
    onClickSearchCondition: function() {
      this.isSearchCondition = !this.isSearchCondition;
      if (this.isSearchCondition) {
        this.isDisplayCondition = false;
      }
    },

    // クリック: 表示項目ボタン
    onClickDisplayCondition: function() {
      this.isDisplayCondition = !this.isDisplayCondition;
      if (this.isDisplayCondition) {
        this.isSearchCondition = false;
      }
    },

    // クリック: 検索条件のクリアボタンクリック
    onClickClearButton: function(_target) {
      this.updatePushName = null;
      this.updateStartDateFrom = null;
      this.updateStartDateTo = null;
      this.updateEndDateFrom = null;
      this.updateEndDateTo = null;
      this.selectedDeliverTypes = [];
      this.selectedDeliverStatuses = [];
      this.selectedMessageTypes = [];
      this.selectedServiceTypes = [];
      this.selectedIsContainsAd = 1;
    },

    // 検索ボタンクリック
    onSearchClick: function(event) {
      event.preventDefault();
      this.pageCountReset();
      this.loadData();
      this.updateSessionStorage();
    },

    showCalendar: function(name) {
      const list = {
        delivery_start_date_from: 'refDeliveryStartDateFrom',
        delivery_start_date_to: 'refDeliveryStartDateTo',
        delivery_end_date_from: 'refDeliveryEndDateFrom',
        delivery_end_date_to: 'refDeliveryEndDateTo',
      };
      Object.keys(list).forEach((key, _index) => {
        if (!this.$refs[list[key]]) return;
        if (name == key) {
          this.$refs[list[key]].$el.querySelector('input').focus();
          this.$refs[list[key]].showCalendar();
        } else {
          this.$refs[list[key]].close(true);
        }
      })
    },

    updateSessionStorage: function() {
      const messageSearchCondition = JSON.parse(sessionStorage.getItem('messageSearchCondition')) || {};

      if (this.pushName) {
        messageSearchCondition.pushName = this.pushName;
      } else {
        delete messageSearchCondition.pushName;
      }
      if (this.startDateFrom) {
        messageSearchCondition.startDateFrom = moment(this.startDateFrom).format('YYYY-MM-DD');
      } else {
        delete messageSearchCondition.startDateFrom;
      }
      if (this.startDateTo) {
        messageSearchCondition.startDateTo = moment(this.startDateTo).format('YYYY-MM-DD');
      } else {
        delete messageSearchCondition.startDateTo;
      }
      if (this.endDateFrom) {
        messageSearchCondition.endDateFrom = moment(this.endDateFrom).format('YYYY-MM-DD');
      } else {
        delete messageSearchCondition.endDateFrom;
      }
      if (this.endDateTo) {
        messageSearchCondition.endDateTo = moment(this.endDateTo).format('YYYY-MM-DD');
      } else {
        delete messageSearchCondition.endDateTo;
      }
      if (this.deliverTypes.length > 0) {
        messageSearchCondition.deliverTypes = this.deliverTypes;
      } else {
        delete messageSearchCondition.deliverTypes;
      }
      if (this.deliverStatuses.length > 0) {
        messageSearchCondition.deliverStatuses = this.deliverStatuses;
      } else {
        delete messageSearchCondition.deliverStatuses;
      }
      if (this.messageTypes.length > 0) {
        messageSearchCondition.messageTypes = this.messageTypes;
      } else {
        delete messageSearchCondition.messageTypes;
      }
      if (this.serviceTypes.length > 0) {
        messageSearchCondition.serviceTypes = this.serviceTypes;
      } else {
        delete messageSearchCondition.serviceTypes;
      }
      if (this.isContainsAd) {
        messageSearchCondition.isContainsAd = this.isContainsAd;
      } else {
        delete messageSearchCondition.isContainsAd;
      }

      sessionStorage.setItem('messageSearchCondition', JSON.stringify(messageSearchCondition));
    },

    retrieveFromSessionStorage: function() {
      const messageSearchCondition = JSON.parse(sessionStorage.getItem('messageSearchCondition')) || {};
      // 詳細検索メニュー表示チェック
      const messageSearchConditionArray = Object.keys(messageSearchCondition);
      this.checkAdvancedSearchMenuDisplay(messageSearchConditionArray);

      this.updatePushName = messageSearchCondition.pushName || '';
      this.updateStartDateFrom = messageSearchCondition.startDateFrom ? moment(messageSearchCondition.startDateFrom, 'YYYY-MM-DD').toDate() : null;
      this.updateStartDateTo = messageSearchCondition.startDateTo ? moment(messageSearchCondition.startDateTo, 'YYYY-MM-DD').toDate() : null;
      this.updateEndDateFrom = messageSearchCondition.endDateFrom ? moment(messageSearchCondition.endDateFrom, 'YYYY-MM-DD').toDate() : null;
      this.updateEndDateTo = messageSearchCondition.endDateTo ? moment(messageSearchCondition.endDateTo, 'YYYY-MM-DD').toDate() : null;
      this.selectedDeliverTypes = messageSearchCondition.deliverTypes || [];
      this.selectedDeliverStatuses = messageSearchCondition.deliverStatuses || [];
      this.selectedMessageTypes = messageSearchCondition.messageTypes || [];
      this.selectedServiceTypes = messageSearchCondition.serviceTypes || [];
      this.selectedIsContainsAd = messageSearchCondition.isContainsAd || 1;
    },

    // 詳細検索メニューをユーザに違和感を与えないようにする処理
    // 広告配信は必ず保存されオブジェクトの要素数の下限は 1 になる
    // また、ワード検索のみ設定時に詳細検索メニューがオープンされると違和感がある
    // ワード検索・広告以外の項目も保存されていたら詳細検索メニューをオープンする
    checkAdvancedSearchMenuDisplay: function (messageSearchConditionArray) {
      if(messageSearchConditionArray.length > 1) {
        const excludedElements = ['isContainsAd', 'pushName'];
        const containsExcludedElements = messageSearchConditionArray.some(item => !excludedElements.includes(item));
        if (containsExcludedElements) {
          this.isSearchCondition = true;
        }
      }
    },
    clearDate: function (event, id) {
      event.preventDefault();
      if (id === 'updateStartDateFrom') {
        this.updateStartDateFrom = null;
      } else if (id === 'updateStartDateTo') {
        this.updateStartDateTo = null;
      } else if (id === 'updateEndDateFrom') {
        this.updateEndDateFrom = null;
      } else if (id === 'updateEndDateTo') {
        this.updateEndDateTo = null;
      }
    },
    setDisplayItems: function (event) {
      this.displayItems = event;
    }
  }
}
</script>

<style>
.bubble-left:after {
    border: 14px solid transparent;
    border-bottom: 21px solid #eef3f6;
    content: '';
    position: absolute;
    right: auto;
    left: 60px !important;
    top: -33px !important;
}
.display-condition {
    width: calc(100% - 540px);
}
</style>
